import { Injectable } from "@angular/core";
import { DataAccess } from "../dataaccess/data.access";

@Injectable()
export class ServicePortalService {
    async clearRulesCache() {
        return DataAccess.get("/rule/trees/cache_flush.json");
    }

    async clearRulesCacheAll() {
        return DataAccess.get("http://gauss.unival.com/25live/data/internal/run/internal/trees/cache_flush_all.json");
    }
}
